export const TAG_CHART_WIDTH = 400;
export const TIMESPAN_NDAYS = Object.freeze({
    ONE_DAY: 1,
    SEVEN_DAYS: 7,
    THIRTY_DAYS: 30,
    NINETY_DAYS: 90,
    SIX_MONTHS: 183,
    ONE_YEAR: 365
});
export const TIMESPAN_OPTIONS = Object.freeze({
    ONE_DAY: '1 Day',
    SEVEN_DAYS: '7 Days',
    THIRTY_DAYS: '30 Days',
    NINETY_DAYS: '90 Days',
    SIX_MONTHS: '6 Months',
    ONE_YEAR: '1 Year',
    CUSTOM: 'Custom'
});
export const PERIOD_SELECTOR_MODES = {
    SIMPLE: 'simple',
    CUSTOM: 'custom'
};
export const PERIOD_SELECTOR_FROM_TRAINING_MODES = {
    TRAINING: 'training',
    TRAINING_NOW: 'training_now'
};
export const DEFAULT_TIME_FORMAT = 'DD-MM-YYYY HH:mm';
export const DEFAULT_EVENTS_PAGE_TIME_FORMAT = 'MMM DD, YYYY HH:mm';
export const MINIMUM_RECONSTRUCTED_RESOLUTION = 10; // 10 Minutes
export const MILLISEC_MINIMUM_RECONSTRUCTED_RESOLUTION = 1000 * 60 * MINIMUM_RECONSTRUCTED_RESOLUTION;
export const EXTERNAL_LINKS_OPTIONS = {
    ALMOND: 'almond',
    MODEL_EDITOR: 'modelEditor'
};
